import {
  Modal,
  Box,
  Typography,
  Button,
  Checkbox,
  FormControlLabel,
} from '@mui/material';
import { t } from 'i18next';
import { useState } from 'react';
import { toast } from 'react-toastify';

interface IResetPasswordModalProps {
  title: string;
  message: string;
  onConfirm: (reset_mfa?: boolean) => Promise<void>;
  onClose: () => void;
  isOpen: boolean;
}

export const ResetPasswordModal = ({
  onClose,
  onConfirm,
  isOpen,
  message,
  title,
}: IResetPasswordModalProps) => {
  const [loading, setLoading] = useState(false);
  const [resetMFA, setResetMFA] = useState(false);

  const toggleResetMFA = () => {
    setResetMFA(!resetMFA);
  };

  const handleConfirm = async () => {
    try {
      setLoading(true);
      await onConfirm(resetMFA);
      onClose();
    } catch {
      toast.error(`Error resetting MFA`);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal open={isOpen} onClose={onClose}>
      <Box
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          bgcolor: 'background.paper',
          boxShadow: 24,
          p: 4,
          borderRadius: 2,
        }}
      >
        <Typography variant='h6' component='h2'>
          {title}
        </Typography>
        <Typography sx={{ mt: 2 }}>{message}</Typography>
        <FormControlLabel
          control={
            <Checkbox
              color='secondary'
              checked={resetMFA}
              onChange={toggleResetMFA}
            />
          }
          color='primary.main'
          label={t('adminPanel.users.resetPassword.resetMFALabel')}
        />

        <Box sx={{ mt: 3, display: 'flex', justifyContent: 'flex-end' }}>
          <Button onClick={onClose} sx={{ mr: 1 }}>
            {t('general.cancel')}
          </Button>
          <Button
            onClick={handleConfirm}
            variant='contained'
            color='secondary'
            loadingPosition='center'
            loading={loading}
            disabled={loading}
            sx={{ color: 'white' }}
          >
            {t('general.continue')}
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};
